import { useEffect, useState } from "react";
import { Mail, Phone } from "lucide-react";
import { PublicLayout } from "@/components/site/PublicLayout";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { api, fileUrl } from "@/lib/api";

export default function Committee() {
    const [members, setMembers] = useState([]);
    useEffect(() => { api.get("/committee").then((r) => setMembers(r.data)); }, []);

    return (
        <PublicLayout>
            <section className="container-x pt-10">
                <Breadcrumbs items={[{ label: "Our Committee" }]} />
                <div className="mt-5 flex flex-wrap items-end justify-between gap-4">
                    <div>
                        <div className="overline">Governance</div>
                        <h1 className="mt-3 font-serif text-5xl leading-tight text-slate-900 sm:text-6xl">Our Committee</h1>
                        <p className="mt-4 max-w-2xl text-lg text-slate-600">
                            The people who lead our association — a mix of experienced society leaders, chartered professionals and passionate volunteers.
                        </p>
                    </div>
                    <div className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-600">
                        <span className="font-semibold text-brand-blue">{members.length}</span> members
                    </div>
                </div>
            </section>

            <section className="container-x mt-12 pb-20">
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {members.map((m) => (
                        <article key={m.id} className="surface-card-hover overflow-hidden" data-testid={`committee-member-${m.id}`}>
                            <div className="relative h-56 bg-gradient-to-br from-brand-blue via-brand-blue-dark to-slate-900">
                                {m.photo_id ? (
                                    <img src={fileUrl(m.photo_id)} alt={m.name} className="h-full w-full object-cover" loading="lazy" />
                                ) : (
                                    <div className="grid h-full place-items-center font-serif text-6xl text-white/30">{m.name.charAt(0)}</div>
                                )}
                                <div className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-[10px] font-semibold uppercase tracking-wider text-brand-blue">
                                    {m.designation}
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="font-serif text-2xl text-slate-900">{m.name}</div>
                                {m.tenure && <div className="text-xs text-slate-500">Tenure: {m.tenure}</div>}
                                {m.description && <p className="mt-3 text-sm text-slate-600">{m.description}</p>}
                                <div className="mt-4 space-y-2 text-sm">
                                    {m.mobile && (
                                        <a href={`tel:${m.mobile}`} className="flex items-center gap-2 text-slate-600 hover:text-brand-blue">
                                            <Phone size={14} className="text-brand-orange" /> {m.mobile}
                                        </a>
                                    )}
                                    {m.email && (
                                        <a href={`mailto:${m.email}`} className="flex items-center gap-2 text-slate-600 hover:text-brand-blue">
                                            <Mail size={14} className="text-brand-orange" /> {m.email}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </PublicLayout>
    );
}
